module.exports = __webpack_public_path__ + "img/shrewd-save-3.0cc2da1f.jpg";